export type CanonicalJobType = 'testcases' | 'playwright' | 'gherkin' | 'synthetic_data';

export function normalizeJobType(input?: string | null): CanonicalJobType {
  const kind = (input || '').trim().toLowerCase();

  if (kind === 'playwright') return 'playwright';
  if (kind === 'gherkin') return 'gherkin';
  if (kind === 'synthetic_data') return 'synthetic_data';

  // Legacy kinds mapped to canonical testcase jobs.
  if (kind === 'requirements' || kind === 'repository_test_cases' || kind === 'code' || kind === 'testcases') {
    return 'testcases';
  }

  return 'testcases';
}

export function jobTypeLabel(jobType: CanonicalJobType): string {
  if (jobType === 'testcases') return 'Test Cases';
  if (jobType === 'playwright') return 'Playwright';
  if (jobType === 'gherkin') return 'Gherkin';
  return 'Synthetic Data';
}
